import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './termsOfUse.scss';
import termsOfUseDefaultContent from './constants';

class TermsOfUse extends React.Component {
  render() {
    return (
      <div>
        {termsOfUseDefaultContent}
      </div>
    );
  }

};

export default withStyles(s)(TermsOfUse);



// WEBPACK FOOTER //
// src/components/utils/termsOfUse/termsOfUse.js